import { useEffect, useState } from 'react';

/**
 * Returns the id of the section crossing a thin band near the top of the viewport.
 * IntersectionObserver only: no scroll listener. When the footer is on screen the last
 * section counts as active, because a short final section may never reach the band.
 */
export default function useActiveSection(ids, footerSelector = '.site-footer') {
  const [active, setActive] = useState(ids[0]);
  const key = ids.join('|');

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') return undefined;
    const list = key.split('|');

    const bandObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    list.forEach((id) => {
      const node = document.getElementById(id);
      if (node) bandObserver.observe(node);
    });

    const footer = document.querySelector(footerSelector);
    const footerObserver = footer
      ? new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) setActive(list[list.length - 1]);
          },
          { threshold: 0.6 }
        )
      : null;
    if (footerObserver) footerObserver.observe(footer);

    return () => {
      bandObserver.disconnect();
      if (footerObserver) footerObserver.disconnect();
    };
  }, [key, footerSelector]);

  return active;
}
